// extracted by mini-css-extract-plugin
module.exports = {"marginRight":"ContentEstimateComponent_marginRight__3BnGU","table":"ContentEstimateComponent_table__3EP-c","errorEstimate":"ContentEstimateComponent_errorEstimate__3yIll"};